import { Css, useTestIds } from "@homebound/beam";
import { emptyCellDash } from "src/components/gridTableCells";
import { Maybe } from "src/generated/graphql-types";
import { formatNumberToString } from "src/utils";

interface PercentageProps {
  id?: string;
  percent: Maybe<number>;
  dropZero?: boolean;
  basisPoints?: boolean;
}

export function Percentage(props: PercentageProps) {
  const { id = "percentage", percent, dropZero = false, basisPoints = false } = props;
  const testId = useTestIds({}, id);
  const value = typeof percent === "number" && basisPoints ? percent / 100 : percent;
  const isNegative = !!value && value < 0;
  const formattedPercentage =
    typeof value !== "number" || (dropZero && value === 0) ? emptyCellDash : `${formatNumberToString(value, true)}%`;
  return (
    <span {...testId} css={Css.if(isNegative).red600.$}>
      {formattedPercentage}
    </span>
  );
}
